<template>
    <div id="app">
        <Navigation v-if="!currentPageIsLogin()"></Navigation>
        <router-view></router-view>

        <notifications group="auth" position="top center" />
    </div>
</template>

<script>
import Navigation from "./views/shared/Navigation.vue";
import { EventBus } from "@/utils/EventBus.js";

export default {
    name: "App",
    components: {
        Navigation
    },
    data() {
        return {
            timer: ""
        };
    },
    created() {
        // refresh does the same as checkLoginStatus() did before
        this.refreshToken();
        // 450000 sind alle 7.5min
        this.timer = setInterval(() => {
            this.refreshToken();
        }, 450000);
        EventBus.$on("session-expired", this.logout);
    },
    beforeDestroy() {
        EventBus.$off("session-expired");
        clearInterval(this.timer);
    },
    methods: {
        refreshToken() {
            return this.$store.dispatch("refreshToken");
        },
        currentPageIsLogin() {
            return this.$route.path.includes("/login");
        },

        logout() {
            if (!this.currentPageIsLogin()) {
                console.log("logout");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
        }
    }
};
</script>

<style lang="scss">
@import "/style/colors.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #7f97d4;
    overflow: hidden;
}
</style>
